import DataValidationTable from './DataValidationTable';
export default DataValidationTable;
